import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  Input,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import Footer from "../../layouts/Footer/Footer";
import Header from "../../layouts/Header/Header";
import styles from "./HomePage.module.scss";
import serviceConfig from "../../../../config/service.json";
import CalculatePriceService from "../../../../services/CalculatePriceService";
import { useLocation } from "react-router";
const SERVICE = process.env.REACT_APP_SERVICE;
const ENV = process.env.REACT_APP_ENV;
const LOW_PLAN = process.env.REACT_APP_LOW_PLAN;
const LOW_POWER_PLAN = process.env.REACT_LOW_POWER_PLAN;
const REACT_ENTRY_PAGE_STOP_SUBMIT = process.env.REACT_ENTRY_PAGE_STOP_SUBMIT;

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const RedTooltip = withStyles({
  tooltip: {
    color: "white",
    fontSize: "13px",
    backgroundColor: "red",
  },
})(Tooltip);

const log = (data: any) => {
  if (ENV !== "production") {
    console.log(data);
  }
};

interface Ampere {
  name: string;
  value: number;
}
let ampereA: Ampere[] = [];
let ampereKVA: Ampere[] = [];
for (let i = 30; i <= 60; i += 10) {
  ampereA = [
    ...ampereA,
    {
      name: i + "A",
      value: i,
    },
  ];
}
for (let j = 6; j <= 49; j += 1) {
  ampereKVA = [
    ...ampereKVA,
    {
      name: j + "kVA",
      value: j * 10,
    },
  ];
}

const meterLightData = {
  hokkaido: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
  tohoku: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
  tokyo: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
  hokuriku: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
  chubu: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
  kansai: {
    meterType: [
      {
        name: "従量電灯A",
        value: "meter_type_A",
      },
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
    ],
    ampere: {
      meter_type_A: [
        {
          name: "--",
          value: 1,
        },
      ],
      meter_type_B: ampereKVA,
    },
  },
  chugoku: {
    meterType: [
      {
        name: "従量電灯A",
        value: "meter_type_A",
      },
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
    ],
    ampere: {
      meter_type_A: [
        {
          name: "--",
          value: 1,
        },
      ],
      meter_type_B: ampereKVA,
    },
  },
  shikoku: {
    meterType: [
      {
        name: "従量電灯A",
        value: "meter_type_A",
      },
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
    ],
    ampere: {
      meter_type_A: [
        {
          name: "--",
          value: 1,
        },
      ],
      meter_type_B: ampereKVA,
    },
  },
  kyusyu: {
    meterType: [
      {
        name: "従量電灯B",
        value: "meter_type_B",
      },
      {
        name: "従量電灯C",
        value: "meter_type_C",
      },
    ],
    ampere: {
      meter_type_B: ampereA,
      meter_type_C: ampereKVA,
    },
  },
};

interface CheckBoxInfo {
  name: string;
  checked: boolean;
}

interface Result {
  basicFee: number;
  paidFee: number;
  fuelFee: number;
  reEnergyFee: number;
  totalFee: number;
  totalYearFee: number;
}

const HomePage = () => {
  const resultRef = useRef<HTMLDivElement>(null);
  const confirmRef = useRef<HTMLDivElement>(null);
  const urlHash = useLocation().hash;

  const isEnabledRegister =
    new Date() >= new Date(process.env.REACT_APP_REGISTER_START_DATE!);

  /**
   * Simulate
   */
  const [serviceContent, setServiceContent] = useState();

  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaSample, setSelectedAreaSample] = useState("");
  const [selectedMeterType, setSelectedMeterType] = useState("");
  const [selectedAmpere, setSelectedAmpere] = useState<number>(0);
  const [selectedKWh, setSelectedKWh] = useState<number>();
  const [selectedFuelFee, setSelectedFuelFee] = useState<number>(0);
  const [selectedFuelFor1kWh, setSelectedFuelFor1kWh] = useState<number>(0);
  const [selectedFuelUnder11kWh, setSelectedFuelUnder11kWh] =
    useState<number>(0);
  const [selectedFuelOver11kWh, setSelectedFuelOver11kWh] = useState<number>(0);

  const [beforeResult, setBeforeResult] = useState<Result>();
  const [afterResult, setAfterResult] = useState<Result>();

  useEffect(() => {
    let isSelectedAll = true;
    if (selectedArea === null || selectedArea === "") {
      isSelectedAll = false;
    }

    if (selectedAmpere === undefined || selectedAmpere === null) {
      isSelectedAll = false;
    }

    if (
      selectedKWh === undefined ||
      selectedKWh === null ||
      _.isEmpty(selectedKWh)
    ) {
      isSelectedAll = false;
    }

    // if (
    //   selectedFuelFee === undefined ||
    //   selectedFuelFee === null ||
    //   _.isEmpty(selectedFuelFee)
    // ) {
    //   isSelectedAll = false;
    // }

    setSelectedAll(isSelectedAll);
  }, [
    selectedArea,
    selectedMeterType,
    selectedAmpere,
    selectedKWh,
    selectedFuelFee,
    selectedFuelUnder11kWh,
    selectedFuelOver11kWh,
    setSelectedFuelFor1kWh,
  ]);

  useEffect(() => {
    if (resultRef !== null && resultRef.current !== null) {
      resultRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [afterResult]);

  const handleChangeArea = (event: any) => {
    if (event.target !== undefined) {
      log(event.target.value);
      setSelectedArea(event.target.value);
      setSelectedAreaSample(
        "/images/common/sample/low/sample_metered_" +
          event.target.value +
          ".png"
      );
      log(_.get(meterLightData, event.target.value).meterType);

      // Reset
      setSelectedMeterType("");
      setSelectedAmpere(0);
      // setSelectedKWh(0);
      setSelectedFuelFee(0);
      setSelectedFuelFor1kWh(0);
      setSelectedFuelUnder11kWh(0);
      setSelectedFuelOver11kWh(0);
    }
  };

  const handleChangeMeterType = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      setSelectedMeterType(event.target.value);

      if (
        ["kansai", "chugoku", "shikoku"].includes(selectedArea) &&
        event.target.value == "meter_type_A"
      ) {
        setSelectedAmpere(1);
      }
    }
  };

  const handleChangeAmpere = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      if (parseFloat(event.target.value) < 0) {
        setSelectedAmpere(0);
      } else {
        setSelectedAmpere(event.target.value);
      }
    }
  };

  const handleChangeKWh = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      if (parseFloat(event.target.value) < 0) {
        setSelectedKWh(0);
      } else {
        setSelectedKWh(event.target.value);
      }
    }
  };

  const handleChangeFuelFee = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      setSelectedFuelFee(event.target.value);
      setSelectedFuelFor1kWh(0);
      setSelectedFuelUnder11kWh(0);
      setSelectedFuelOver11kWh(0);
    }
  };

  const handleChangeFuelFor1kWh = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      setSelectedFuelFor1kWh(event.target.value);
      setSelectedFuelFee(0);
      setSelectedFuelUnder11kWh(0);
      setSelectedFuelOver11kWh(0);
    }
  };

  const handleChangeFuelUnder11kWh = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      setSelectedFuelUnder11kWh(event.target.value);
      setSelectedFuelFee(0);
      setSelectedFuelFor1kWh(0);
    }
  };

  const handleChangeFuelOver11kWh = (event: any) => {
    log(event.target.value);
    if (event.target !== undefined) {
      setSelectedFuelOver11kWh(event.target.value);
      setSelectedFuelFee(0);
      setSelectedFuelFor1kWh(0);
    }
  };

  const handleSimulate = () => {
    if (!selectedAll) {
      return;
    }

    const oldResult = CalculatePriceService({
      type: "old",
      service: SERVICE,
      plan: LOW_PLAN || "plan_basic_0",
      area: selectedArea,
      meter_type: selectedMeterType,
      ampere: _.toNumber(selectedAmpere || 0),
      kWh: _.toNumber(selectedKWh || 0),
      fuel_price: _.toNumber(selectedFuelFee || 0),
      fuel_for_1kwh: _.toNumber(selectedFuelFor1kWh || 0),
      fuel_under_11kwh: _.toNumber(selectedFuelUnder11kWh || 0),
      fuel_over_11kWh: _.toNumber(selectedFuelOver11kWh || 0),
    });

    const newResult = CalculatePriceService({
      type: "new",
      service: SERVICE,
      plan: LOW_PLAN || "plan_basic_0",
      area: selectedArea,
      meter_type: selectedMeterType,
      ampere: selectedAmpere || 0,
      kWh: selectedKWh || 0,
      fuel_price: selectedFuelFee || 0,
      fuel_for_1kwh: _.toNumber(selectedFuelFor1kWh || 0),
      fuel_under_11kwh: selectedFuelUnder11kWh || 0,
      fuel_over_11kWh: selectedFuelOver11kWh || 0,
    });

    log(["oldResult", oldResult]);
    log(["newResult", newResult]);

    setBeforeResult((beforeResult) => oldResult);
    setAfterResult((afterResult) => newResult);

    if (resultRef !== null && resultRef.current !== null) {
      resultRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleConfirm = () => {
    setConfirmed(true);
    if (confirmRef !== null && confirmRef.current !== null) {
      confirmRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  /**
   * Confirm
   */
  const [confirmed, setConfirmed] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [checkBoxes, setCheckBoxes] = useState<CheckBoxInfo[]>([]);

  const handleChangeCheckBox = (event: any) => {
    let newCheckBoxes = [...checkBoxes];
    newCheckBoxes.map((checkBox: any) => {
      if (checkBox.name === event.target.name) {
        checkBox.checked = event.target.checked;
      }
    });
    setCheckBoxes(newCheckBoxes);
    log(["Checkbox", newCheckBoxes]);
  };

  useEffect(() => {
    if (
      serviceConfig !== undefined &&
      SERVICE !== undefined &&
      LOW_PLAN !== undefined &&
      _.get(serviceConfig, SERVICE) !== undefined &&
      _.get(_.get(serviceConfig, SERVICE), LOW_PLAN) !== undefined &&
      _.get(_.get(serviceConfig, SERVICE), LOW_PLAN).confirm_info !== undefined
    ) {
      const serviceContent = _.get(_.get(serviceConfig, SERVICE), LOW_PLAN);
      if (serviceContent !== undefined && serviceContent !== null) {
        setServiceContent(serviceContent);
        _.get(serviceContent, "confirm_info", []).map((row: any) => {
          if (!_.isEmpty(row.checkbox)) {
            setCheckBoxes((checkBoxes) => [
              ...checkBoxes,
              {
                name: row.checkbox,
                checked: false,
              },
            ]);
          }
        });
      }
    }

    if (urlHash === "#confirm") {
      setConfirmed(true);
    }
  }, []);

  useEffect(() => {
    let allCheck = true;
    checkBoxes.map((checkBox: any) => {
      if (!checkBox.checked) {
        allCheck = false;
      }
    });
    setAllChecked(allCheck);
  }, [checkBoxes]);

  useEffect(() => {
    if (confirmRef !== null && confirmRef.current !== null) {
      confirmRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [confirmed]);

  return (
    <>
      <Header />
      <div className={styles.HomePage}>
        {urlHash !== "#confirm" && (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Typography variant="h4" style={{ marginTop: "10px" }}>
              料金シミュレーション
            </Typography>
            <Typography variant="h6" style={{ margin: "10px 10px" }}>
              シミュレーションが不要な方は「お申し込みはこちら」へお進みください。
            </Typography>

            <Card className={`${styles.Card} ${styles.ColorGrey}`}>
              <CardContent className={`${styles.ColorWhite}`}>
                <Grid
                  container
                  spacing={5}
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={7} sm={8} md={4}>
                    <div className={styles.Title}>
                      ①お住まいの電力エリアを選択してください。
                    </div>
                    <div className={styles.Content}>
                      ※選択できないエリアは現在対応していないエリアとなっております。
                    </div>
                  </Grid>
                  <Grid item xs={5} sm={4} md={3}>
                    <Select
                      className={styles.Select}
                      onChange={handleChangeArea}
                      value={selectedArea}
                    >
                      {_.get(serviceContent, "areas", []).map(
                        (areaData: any) => {
                          return (
                            <MenuItem
                              key={areaData.value}
                              value={areaData.value}
                              disabled={!areaData.status}
                            >
                              {areaData.name}
                            </MenuItem>
                          );
                        }
                      )}
                    </Select>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* {selectedArea && (
              <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                <CardContent className={`${styles.ColorWhite}`}>
                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item xs={12} md={10} sm={8}>
                      <img
                        className={styles.Image}
                        src={selectedAreaSample}
                        alt="sample"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )} */}

            <Card className={`${styles.Card} ${styles.ColorGrey}`}>
              <CardContent className={`${styles.ColorWhite}`}>
                <Grid
                  container
                  spacing={5}
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={7} sm={8} md={4}>
                    <div className={styles.Title}>
                      ②ご契約種別を選択してください。
                    </div>
                  </Grid>
                  <Grid item xs={5} sm={4} md={3}>
                    <Select
                      className={styles.Select}
                      value={selectedMeterType}
                      disabled={!selectedArea}
                      onChange={handleChangeMeterType}
                    >
                      {!_.isEmpty(_.get(meterLightData, selectedArea)) &&
                        _.get(meterLightData, selectedArea).meterType.map(
                          (meterTypeData: any) => {
                            return (
                              <MenuItem
                                key={meterTypeData.value}
                                value={meterTypeData.value}
                              >
                                {meterTypeData.name}
                              </MenuItem>
                            );
                          }
                        )}
                    </Select>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card className={`${styles.Card} ${styles.ColorGrey}`}>
              <CardContent
                className={`${
                  selectedMeterType === "meter_type_A" &&
                  ["kansai", "chugoku", "shikoku"].includes(selectedArea)
                    ? styles.ColorGrey
                    : styles.ColorWhite
                }`}
              >
                <Grid
                  container
                  spacing={5}
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={7} sm={8} md={4}>
                    <div className={styles.Title}>
                      ③ご契約容量を選択してください。
                    </div>
                  </Grid>
                  <Grid item xs={5} sm={4} md={3}>
                    <Select
                      className={styles.Select}
                      value={selectedAmpere}
                      disabled={!selectedMeterType}
                      onChange={handleChangeAmpere}
                    >
                      {!_.isEmpty(selectedArea) &&
                        !_.isEmpty(selectedMeterType) &&
                        !_.isEmpty(_.get(meterLightData, selectedArea)) &&
                        !_.isEmpty(
                          _.get(meterLightData, selectedArea).ampere
                        ) &&
                        !_.isEmpty(
                          _.get(
                            _.get(meterLightData, selectedArea).ampere,
                            selectedMeterType
                          )
                        ) &&
                        _.get(
                          _.get(meterLightData, selectedArea).ampere,
                          selectedMeterType
                        ).map((ampere: any) => {
                          return (
                            <MenuItem key={ampere.value} value={ampere.value}>
                              {ampere.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card className={`${styles.Card} ${styles.ColorGrey}`}>
              <CardContent className={`${styles.ColorWhite}`}>
                <Grid
                  container
                  spacing={5}
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={7} sm={8} md={4}>
                    <div className={styles.Title}>
                      ④ご使用量を入力してください。
                    </div>
                  </Grid>
                  <Grid item xs={5} sm={4} md={3}>
                    <Input
                      type="number"
                      className={styles.Input}
                      value={selectedKWh}
                      disabled={!selectedAmpere}
                      endAdornment={
                        <InputAdornment position="end">kWh</InputAdornment>
                      }
                      onChange={handleChangeKWh}
                    ></Input>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {selectedArea !== "shikoku" && (
              <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                <CardContent className={`${styles.ColorWhite}`}>
                  <Grid
                    container
                    spacing={5}
                    direction="row"
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item xs={7} sm={8} md={4}>
                      <div className={styles.Title}>
                        ⑤燃料費調整額を入力してください。
                      </div>
                      <div className={styles.Content}>
                        マイナスの場合「-」も入力してください。
                      </div>
                    </Grid>
                    <Grid item xs={5} sm={4} md={3}>
                      <Input
                        type="number"
                        className={styles.Input}
                        value={selectedFuelFee}
                        disabled={!selectedAmpere}
                        endAdornment={
                          <InputAdornment position="end">円</InputAdornment>
                        }
                        onChange={handleChangeFuelFee}
                      ></Input>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            {selectedArea === "shikoku" && (
              <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                <CardContent className={`${styles.ColorWhite}`}>
                  <Grid
                    container
                    spacing={5}
                    direction="row"
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item xs={7} sm={8} md={4}>
                      <div className={styles.Title}>
                        ⑤燃料費調整単価を入力してください。
                      </div>
                      <div className={styles.Content}>
                        マイナスの場合「-」も入力してください。
                      </div>
                    </Grid>
                    <Grid item xs={5} sm={4} md={3}>
                      <Grid container direction="row">
                        <Grid item xs={12} sm={12} md={7}>
                          <Typography variant="caption">
                            最初の11kWhまで
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={5}>
                          <Input
                            type="number"
                            className={styles.Input}
                            value={selectedFuelUnder11kWh}
                            disabled={!selectedAmpere}
                            endAdornment={
                              <InputAdornment position="end">円</InputAdornment>
                            }
                            onChange={handleChangeFuelUnder11kWh}
                          ></Input>
                        </Grid>
                      </Grid>

                      <Grid container direction="row">
                        <Grid item xs={12} sm={12} md={7}>
                          <Typography variant="caption">
                            上記をこえる1kWhにつき
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={5}>
                          <Input
                            type="number"
                            className={styles.Input}
                            value={selectedFuelOver11kWh}
                            disabled={!selectedAmpere}
                            endAdornment={
                              <InputAdornment position="end">円</InputAdornment>
                            }
                            onChange={handleChangeFuelOver11kWh}
                          ></Input>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            <Grid
              container
              spacing={0}
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <RedTooltip
                  placement="top"
                  title={!selectedAll ? "すべての確認項目をご入力ください" : ""}
                >
                  <Button
                    color="secondary"
                    variant="contained"
                    className={
                      selectedAll
                        ? `${styles.Button}`
                        : `${styles.ButtonDisabled}`
                    }
                    onClick={handleSimulate}
                  >
                    計算する
                  </Button>
                </RedTooltip>
              </Grid>

              {isEnabledRegister && (
                <Grid item>
                  <Button
                    color="secondary"
                    variant="contained"
                    className={styles.Button}
                    onClick={handleConfirm}
                  >
                    お申し込みはこちら
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}

        {urlHash !== "#confirm" &&
          beforeResult !== undefined &&
          afterResult !== undefined && (
            <div ref={resultRef} style={{ marginTop: "50px" }}>
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Card className={`${styles.Card} ${styles.ColorYellow}`}>
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item>
                      <div>
                        <Typography variant="h5">
                          シミュレーション結果
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Card>

                {/* <Card
                  className={`${styles.Card} ${styles.ColorF3F3F3} `}
                  style={{ marginTop: "10px" }}
                >
                  <CardContent className={`${styles.ColorF3F3F3}`}>
                    <Grid
                      container
                      spacing={5}
                      direction="row"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid item xs={6} sm={8} md={4}>
                        <div className={`${styles.Title} ${styles.fontSize20}`}>
                          これまでの年間電気料金
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <Typography variant="h4">
                          {(beforeResult?.totalYearFee).toLocaleString(
                            undefined,
                            {
                              maximumFractionDigits: 2,
                            }
                          )}
                          円
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                <Grid
                  container
                  spacing={0}
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <div className={styles.DownArrow}>
                    <img src="/images/common/down_arrow.png" alt="arrow" />
                  </div>
                </Grid> */}

                <Card className={`${styles.Card} ${styles.ColorFAEEB1}`}>
                  <CardContent className={`${styles.ColorFAEEB1}`}>
                    <Grid
                      container
                      spacing={5}
                      direction="row"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid item xs={6} sm={8} md={4}>
                        {_.get(serviceContent, "name", null) && (
                          <div
                            className={`${styles.Title} ${styles.fontSize20}`}
                          >
                            {_.get(serviceContent, "name", null)}の年間電気料金
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <Typography variant="h4">
                          {afterResult.totalYearFee.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                          円
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* <Card
                  className={`${styles.Card} ${styles.ColorD9ECF0}`}
                  style={{ marginTop: "10px" }}
                >
                  <CardContent className={`${styles.ColorD9ECF0}`}>
                    <Grid
                      container
                      spacing={5}
                      direction="row"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid item xs={2} sm={4} md={2}>
                        <div
                          className={`${styles.Title} ${styles.fontSize20} ${styles.TextRed}`}
                        >
                          年間
                        </div>
                      </Grid>
                      <Grid item xs={5} sm={4} md={2}>
                        <Typography
                          variant="h4"
                          className={`${styles.TextRed}`}
                        >
                          {Math.abs(
                            beforeResult?.totalYearFee -
                              afterResult?.totalYearFee
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}
                          円
                        </Typography>
                      </Grid>
                      <Grid item xs={5} sm={4} md={2}>
                        {beforeResult?.totalYearFee -
                          afterResult?.totalYearFee >=
                          0 && (
                          <Typography
                            className={`${styles.TextRed} ${styles.fontSize20}`}
                          >
                            安くなります。
                          </Typography>
                        )}
                        {beforeResult?.totalYearFee -
                          afterResult?.totalYearFee <
                          0 && (
                          <Typography
                            className={`${styles.TextRed} ${styles.fontSize20}`}
                          >
                            高くなります。
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card> */}

                {/* <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                <CardContent className={`${styles.ColorWhite}`}> */}
                <Grid
                  container
                  spacing={0}
                  direction="row"
                  alignItems="center"
                  justify="center"
                  className={styles.Table}
                  style={{ marginTop: "10px" }}
                >
                  <Grid item xs={12}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              className={`${styles.ColorGrey} ${styles.TextWhite} ${styles.fontSize16}`}
                              align="center"
                            >
                              項目
                            </TableCell>
                            {/* <TableCell
                              className={`${styles.ColorGrey} ${styles.TextWhite} ${styles.fontSize16}`}
                              align="center"
                            >
                              これまでの電気料金
                            </TableCell> */}
                            <TableCell
                              className={`${styles.ColorYellow} ${styles.TextWhite} ${styles.fontSize16}`}
                              align="center"
                            >
                              {_.get(serviceContent, "name", null) && (
                                <>{_.get(serviceContent, "name", null)}</>
                              )}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <StyledTableRow>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              className={`${styles.fontSize16}`}
                            >
                              基本料金
                            </StyledTableCell>
                            {/* <StyledTableCell
                              align="right"
                              className={`${styles.fontSize16}`}
                            >
                              {beforeResult.basicFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell> */}
                            <StyledTableCell
                              className={`${styles.ColorYellow75} ${styles.fontSize16}`}
                              align="right"
                            >
                              {afterResult.basicFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell>
                          </StyledTableRow>
                          <StyledTableRow>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              className={`${styles.fontSize16}`}
                            >
                              電力量料金
                            </StyledTableCell>
                            {/* <StyledTableCell
                              align="right"
                              className={`${styles.fontSize16}`}
                            >
                              {beforeResult.paidFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell> */}
                            <StyledTableCell
                              className={`${styles.ColorYellow50} ${styles.fontSize16}`}
                              align="right"
                            >
                              {afterResult.paidFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell>
                          </StyledTableRow>
                          <StyledTableRow>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              className={`${styles.fontSize16}`}
                            >
                              燃料費調整額
                            </StyledTableCell>
                            {/* <StyledTableCell
                              align="right"
                              className={`${styles.fontSize16}`}
                            >
                              {beforeResult.fuelFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell> */}
                            <StyledTableCell
                              className={`${styles.ColorYellow75} ${styles.fontSize16}`}
                              align="right"
                            >
                              {afterResult.fuelFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell>
                          </StyledTableRow>
                          <StyledTableRow>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              className={`${styles.fontSize16}`}
                            >
                              再エネ賦課金
                            </StyledTableCell>
                            {/* <StyledTableCell
                              align="right"
                              className={`${styles.fontSize16}`}
                            >
                              {beforeResult.reEnergyFee.toLocaleString(
                                undefined,
                                {
                                  maximumFractionDigits: 2,
                                }
                              )}{" "}
                              円
                            </StyledTableCell> */}
                            <StyledTableCell
                              className={`${styles.ColorYellow50} ${styles.fontSize16}`}
                              align="right"
                            >
                              {afterResult.reEnergyFee.toLocaleString(
                                undefined,
                                {
                                  maximumFractionDigits: 2,
                                }
                              )}{" "}
                              円
                            </StyledTableCell>
                          </StyledTableRow>
                          <StyledTableRow>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              className={`${styles.fontSize16} ${styles.fontWeight600}`}
                            >
                              毎月の電気料金
                            </StyledTableCell>
                            {/* <StyledTableCell
                              align="right"
                              className={`${styles.fontSize16} ${styles.fontWeight600}`}
                            >
                              {beforeResult.totalFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell> */}
                            <StyledTableCell
                              className={`${styles.ColorYellow75} ${styles.fontSize16} ${styles.fontWeight600}`}
                              align="right"
                            >
                              {afterResult.totalFee.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })}{" "}
                              円
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                {/* </CardContent>
              </Card> */}

                {isEnabledRegister && (
                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    justify="center"
                    alignItems="center"
                    style={{ padding: "0px 10px", marginTop: "30px" }}
                  >
                    <Grid item xs={12}>
                      <Typography>
                        切り替え後の料金にご納得いただけましたら、お申し込みフォームへお進みください。
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ margin: "20px 0px" }}>
                      <Button
                        color="secondary"
                        variant="contained"
                        className={styles.Button}
                        onClick={handleConfirm}
                      >
                        お申し込みはこちら
                      </Button>
                    </Grid>
                  </Grid>
                )}

                <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                  <CardContent className={`${styles.ColorWhite}`}>
                    <Grid
                      container
                      spacing={2}
                      direction="column"
                      justify="center"
                      alignItems="center"
                    >
                      {_.get(serviceContent, "simulation_info", null) && (
                        <Grid item xs={12}>
                          <Typography
                            style={_.get(
                              _.get(serviceContent, "simulation_info"),
                              "style"
                            )}
                          >
                            {_.get(
                              _.get(serviceContent, "simulation_info"),
                              "title"
                            )}
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        {_.get(
                          _.get(serviceContent, "simulation_info"),
                          "contents",
                          []
                        ).map((content: any) => {
                          return (
                            <>
                              {content.type === "typography" && (
                                <ul>
                                  <li
                                    style={{
                                      ...{
                                        whiteSpace: "pre-line",
                                      },
                                      ...content.style,
                                    }}
                                  >
                                    {content.text}
                                  </li>
                                </ul>
                              )}
                              {content.type === "button" && (
                                <Button
                                  href={content.url}
                                  className={styles.ButtonOrange}
                                  style={content.style}
                                >
                                  {content.text}
                                </Button>
                              )}
                              {content.type === "checkbox" && (
                                <Checkbox
                                  name={content.text}
                                  color="primary"
                                  style={content.style}
                                />
                              )}
                              {content.type === "image" &&
                                _.isEmpty(content.url) && (
                                  <img
                                    src={content.src}
                                    width={content.width}
                                    height={content.height}
                                    style={content.style}
                                    alt="content image"
                                  />
                                )}
                              {content.type === "image" &&
                                !_.isEmpty(content.url) && (
                                  <a href={content.url} target="_blank">
                                    <img
                                      src={content.src}
                                      width={content.width}
                                      height={content.height}
                                      style={content.style}
                                      alt="content image"
                                    />
                                  </a>
                                )}
                            </>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </div>
          )}

        {confirmed === true && (
          <div ref={confirmRef} style={{ marginTop: "50px" }}>
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Card className={`${styles.Card} ${styles.ColorYellow}`}>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item>
                    <Typography variant="h5">お申し込み</Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Card className={`${styles.Card}`}>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item>
                    <img
                      src="/images/common/confirm_step.png"
                      width="100%"
                      alt="step"
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            {_.get(serviceContent, "confirm_info", []).map((row: any) => {
              return (
                <>
                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                  >
                    <Card
                      className={`${styles.Card} ${styles.ColorGrey} ${styles.TextWhite}`}
                    >
                      <Grid
                        container
                        spacing={0}
                        direction="row"
                        alignItems="center"
                        justify="center"
                      >
                        <Grid item>
                          <Typography style={row.style} variant="h5">
                            {row.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                  >
                    <Card className={`${styles.Card} ${styles.ColorGrey}`}>
                      <CardContent className={`${styles.ColorWhite}`}>
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justify="center"
                        >
                          <Grid item xs={12}>
                            {row.info &&
                              row.info.map((info: any) => {
                                return (
                                  <>
                                    {info.title && (
                                      <Typography style={info.style}>
                                        《 {info.title} 》
                                      </Typography>
                                    )}
                                    {info.contents &&
                                      info.contents.map((content: any) => {
                                        return (
                                          <>
                                            {content.type === "typography" && (
                                              <ul>
                                                <li
                                                  style={{
                                                    ...{
                                                      whiteSpace: "pre-line",
                                                    },
                                                    ...content.style,
                                                  }}
                                                >
                                                  {content.text}
                                                </li>
                                              </ul>
                                            )}
                                            {content.type === "button" && (
                                              <Button
                                                href={content.url}
                                                target="_blank"
                                                // color="secondary"
                                                variant="outlined"
                                                className={styles.Button}
                                                style={content.style}
                                              >
                                                {content.text}
                                              </Button>
                                            )}
                                            {content.type === "checkbox" && (
                                              <Checkbox
                                                name={content.text}
                                                color="primary"
                                                style={content.style}
                                              />
                                            )}
                                            {content.type === "image" &&
                                              _.isEmpty(content.url) && (
                                                <img
                                                  src={content.src}
                                                  width={content.width}
                                                  height={content.height}
                                                  style={content.style}
                                                  alt="content image"
                                                />
                                              )}
                                            {content.type === "image" &&
                                              !_.isEmpty(content.url) && (
                                                <a
                                                  href={content.url}
                                                  target="_blank"
                                                >
                                                  <img
                                                    src={content.src}
                                                    width={content.width}
                                                    height={content.height}
                                                    style={content.style}
                                                    alt="content image"
                                                  />
                                                </a>
                                              )}
                                          </>
                                        );
                                      })}
                                    <br />
                                  </>
                                );
                              })}
                          </Grid>
                        </Grid>
                        {row.checkbox && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={row.checkbox}
                                onChange={handleChangeCheckBox}
                                style={row.style}
                              />
                            }
                            label={row.checkbox}
                            className={styles.TextRed}
                          />
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                </>
              );
            })}

            {_.get(serviceContent, "register_url_type_change", null) !== null &&
              _.get(serviceContent, "register_url_type_new", null) !== null &&
              REACT_ENTRY_PAGE_STOP_SUBMIT === "false" && (
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <Grid item>
                    <RedTooltip
                      placement="top"
                      title={
                        !allChecked ? "すべての確認項目をご同意ください" : ""
                      }
                    >
                      <Button
                        color="secondary"
                        variant="contained"
                        className={
                          allChecked
                            ? `${styles.ButtonRed}`
                            : `${styles.ButtonRedDisabled}`
                        }
                        href={
                          allChecked
                            ? _.get(
                                serviceContent,
                                "register_url_type_change",
                                ""
                              )
                            : ""
                        }
                        target="_blank"
                      >
                        電力会社切り替えのお申込み画面へ　
                      </Button>
                    </RedTooltip>
                  </Grid>

                  <Grid item>
                    <RedTooltip
                      placement="top"
                      title={
                        !allChecked ? "すべての確認項目をご同意ください" : ""
                      }
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        className={
                          allChecked
                            ? `${styles.ButtonBlue}`
                            : `${styles.ButtonBlueDisabled}`
                        }
                        href={
                          allChecked
                            ? _.get(serviceContent, "register_url_type_new", "")
                            : ""
                        }
                        target="_blank"
                      >
                        新しい住所へ引越しのお申込み画面へ
                      </Button>
                    </RedTooltip>
                  </Grid>
                </Grid>
              )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
